var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "06_\u7528\u6237\u7537") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52,45.35l-10.6-4.13a10.9,10.9,0,0,1-2.8-1.55c-.51-.5-.47-1.67,0-3.16s5.87-7.57,5.87-13.09C44.48,14.9,38.88,8,32,8S19.46,14.9,19.46,23.42c0,5.29,4.84,11.59,5.44,12.73a3.77,3.77,0,0,1,0,3.42c-.71.79-3.3,1.59-3.3,1.59L12,45.42a5.85,5.85,0,0,0-4,5.28v1.12c0,2.6,2.11,4.18,4.69,4.18H51.32C53.9,56,56,54.42,56,51.82V50.7a5.94,5.94,0,0,0-4-5.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.64336d3b.svg";
export { ForwardRef as ReactComponent };